import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isfetching: false,
  cardId: null,
  isSuccess: false,
  success: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionConstants.USER_CARD_CREATE_REQUEST:
      return {
        ...state,
        isfetching: true,
        isSuccess: false,
        success: '',
        error: '',
      };
    case actionConstants.USER_CARD_CREATE_SUCCESS:
      return {
        ...state,
        cardId: action.payload,
        isfetching: false,
        isSuccess: true,
        success: action.message,
      };
    case actionConstants.USER_CARD_CREATE_FAILURE:
      return {
        ...state,
        error: action.message,
        isfetching: false
      };
    case actionConstants.USER_CARD_CREATE_CLEAR:
      return {
        ...state,
        cardId: null,
        isSuccess: false,
        error: '',
        success: '',
      };
    default:
      return state;
  }
};
